import React from 'react';
import Icon from '@mdi/react';
import { mdiHumanMaleBoard } from '@mdi/js';
import theme from '../theme'; 

export const TeacherIcon = size => (
  <Icon 
    size={size}
    path={mdiHumanMaleBoard}
    title="Teacher"
    color={theme.white}
  />
);